"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var react_query_1 = require("@tanstack/react-query");
var useAuth_1 = require("../auth/useAuth");
var useGetUserSettings = function () {
    var _a = (0, useAuth_1.useAuth)(), getClientId = _a.getClientId, getCognitoUserSessionToken = _a.getCognitoUserSessionToken, email = _a.email;
    var getUserSettings = (0, react_1.useCallback)(function () { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
        var response, _a, _b, data, _c;
        var _d, _e;
        return (0, tslib_1.__generator)(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 4, , 5]);
                    _a = fetch;
                    _b = ["/api/settings/user?email=".concat(email)];
                    _d = {
                        method: 'GET'
                    };
                    _e = {};
                    return [4 /*yield*/, getCognitoUserSessionToken()];
                case 1: return [4 /*yield*/, _a.apply(void 0, _b.concat([(_d.headers = (_e.Authorization = (_f.sent()) || '',
                            _e['x-ntfos-set-clientid'] = getClientId(),
                            _e),
                            _d)]))];
                case 2:
                    response = _f.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _f.sent();
                    if ((data === null || data === void 0 ? void 0 : data.userid) <= 0) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, {
                            dbname: data.dbname,
                            dbalias: data.dbalias,
                            userid: data.userid,
                        }];
                case 4:
                    _c = _f.sent();
                    return [2 /*return*/, null];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [email, getClientId, getCognitoUserSessionToken]);
    return (0, react_query_1.useQuery)(['USER_DATA', email], getUserSettings);
};
exports.default = useGetUserSettings;
